module.exports = __webpack_public_path__ + "static/img/newstatemin.ce2176d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newstatemin.jpeg
// module id = wbis
// module chunks = 0